import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminHome.css';

const AdminHome: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('hitster-admin');
    localStorage.removeItem('hitster-admin-bridge');
    navigate('/admin-login');
  };

  return (
    <div className="admin-home-page">
      <header className="admin-home-header">
        <h1>Admin Startpagina</h1>
        <button className="btn-ghost" onClick={handleLogout}>Uitloggen</button>
      </header>

      <div className="admin-home-grid">
        <article className="admin-tile">
          <div className="tile-icon">🎵</div>
          <h2>Spotify Dashboard</h2>
          <p>Beheer nummers, ronden en Hitster-evenementen.</p>
          <button className="btn-primary" onClick={() => navigate('/spotify-dashboard')}>
            Open Spotify Dashboard
          </button>
        </article>

        <article className="admin-tile">
          <div className="tile-icon">🔍</div>
          <h2>Crimespel</h2>
          <p>Open het nieuwe cold case platform voor gelicenseerde deelnemers.</p>
          <button className="btn-primary" onClick={() => window.location.href = '/crimespel/admin-login?sso=1'}>
            Open Crimespel beheer
          </button>
        </article>
      </div>
    </div>
  );
};

export default AdminHome;
